import {createSelector} from '@reduxjs/toolkit'

import {RootState} from '../../store'
import {BookingCreationStage, RedirectContext, ThreeDSContext} from './slice'

/**
 * Get the current stage
 */
export const getBookingCreationStage = (
  state: RootState
): BookingCreationStage => state.bookingCreation.stage

/**
 * Get the redirect context (analytics values for the payment redirect thunk)
 */
export const getRedirectContext = (state: RootState): RedirectContext | null =>
  state.bookingCreation.redirectContext

/**
 * Whether the current booking was created via the charge-later mutation.
 */
export const getIsChargeLaterBookingCreation = (state: RootState): boolean =>
  state.bookingCreation.threeDSContext?.isChargeLaterBookingCreation ?? false

/**
 * 3DS context (booking status links), populated when 3DS is detected.
 */
export const getThreeDSContext = (state: RootState): ThreeDSContext | null =>
  state.bookingCreation.threeDSContext

const SUBMITTING_STAGES: BookingCreationStage[] = [
  BookingCreationStage.Creating,
  BookingCreationStage.Awaiting3ds,
  BookingCreationStage.Finalizing,
  BookingCreationStage.Redirecting
]

/**
 * Check if booking is currently processing
 */
export const getIsSubmitting = createSelector(
  getBookingCreationStage,
  (stage): boolean => SUBMITTING_STAGES.includes(stage)
)
